import {OperatorFunction, Subscriber} from 'rxjs';

class NeverSubscriber<T> extends Subscriber<T> {

    protected override _next(): void {
        // Don't pass events.
    }
}

/**
 * RxJs pipeable operator.
 * Prevents passing further any events except complete and error.
 * Has effect similar to filter(() => false), but also tells TypeScript
 * that the result is Observable<never>.
 * @returns {(source: Observable<T>) => Observable<T>}
 */
export function toNever<T>(): OperatorFunction<T, never> {
    return source => source.lift({
        call: subscriber =>
                  source.subscribe(new NeverSubscriber(subscriber))
    });
}
